var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"mobile-filters-toggle d-lg-none",class:{ 'is-open': _vm.isOpen },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fas fa-sliders-h"}),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }